import { render, staticRenderFns } from "./AddSinglePin.vue?vue&type=template&id=3787d5f5"
import script from "./AddSinglePin.vue?vue&type=script&lang=js"
export * from "./AddSinglePin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports